import React from "react";

export default function SQLServer_ATAN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_ATAN</h1>
      <p>This is the SQLServer_ATAN component generated from the SQL JSON.</p>
    </div>
  );
}
